import { z } from "zod";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { EmailListInput } from "./EmailListInput";
import { ProductPricePreferenceCheckboxGroup } from "./ProductPricePreferenceCheckboxGroup";
import { estimatedPriceUpdatePreferencesSchema, PRODUCT_CONFIGS_FOR_ESTIMATED_PRICE_UPDATE } from "./schema";

export type PriceUpdatePreferencesFormValues = z.infer<typeof estimatedPriceUpdatePreferencesSchema>;

interface PricePreferenceAccordionProps {
  index: number;
}

export function PricePreferenceAccordion({ index }: PricePreferenceAccordionProps) {
  return (
    <Accordion type="single" collapsible className="w-full">
      <AccordionItem value="preferences">
        <AccordionTrigger className="w-full">Price Update Preferences</AccordionTrigger>
        <AccordionContent>
          <div className="space-y-6">
            <div className="space-y-4">
              <h4 className="text-sm font-medium">Email Recipients</h4>
              <EmailListInput
                name={`userClientLinks.${index}.cc_recipients`}
                label="CC Recipients"
                description="Enter email addresses for CC recipients of price update emails."
                placeholder="Enter email address"
              />
              <EmailListInput
                name={`userClientLinks.${index}.bcc_recipients`}
                label="BCC Recipients"
                description="Enter email addresses for BCC recipients of price update emails."
                placeholder="Enter email address"
              />
            </div>
            <div className="space-y-6">
              <h4 className="text-sm font-medium">Product Preferences</h4>
              {Object.entries(PRODUCT_CONFIGS_FOR_ESTIMATED_PRICE_UPDATE).map(([key, config]) => (
                <ProductPricePreferenceCheckboxGroup
                  key={key}
                  title={config.title}
                  basePath={`userClientLinks.${index}.estimated_price_update_preferences.${config.path}`}
                  products={config.products}
                  contracts={config.contracts}
                  showLongHorizonSwitch={config.path === "sparkspread"}
                />
              ))}
            </div>
          </div>
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  );
}
